import React from 'react';
interface SegmentedControlProps<T extends string> {
  options: {
    value: T;
    label: string;
  }[];
  value: T;
  onChange: (v: T) => void;
  ariaLabel: string;
}
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ariaLabel
}: SegmentedControlProps<T>) {
  return <div role="tablist" aria-label={ariaLabel} className="inline-flex rounded-md border border-line bg-canvas p-0.5" data-id="element-738" data-mp="1nsrcwv2xpr2j">
      {options.map(o => {
      const active = o.value === value;
      return <button key={o.value} type="button" role="tab" aria-selected={active} onClick={() => onChange(o.value)} className={`whitespace-nowrap rounded px-3 py-1.5 text-xs transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy/30 ${active ? 'bg-white font-semibold text-navy shadow-sm' : 'font-medium text-ink-muted hover:text-ink'}`} data-id="element-739" data-mp="v5epyjsv3h8p">
            {o.label}
          </button>;
    })}
    </div>;
}